import type { PlatformPlugin } from "@acto/taskpane/core/platform/PlatformPlugin";

async function registerServiceWorker() {
  if (typeof window === "undefined" || typeof navigator === "undefined" || typeof document === "undefined") {
    return;
  }

  const register = async () => {
    try {
      await navigator.serviceWorker.register("/sw.js");
    } catch {
      console.error("Service worker registration failed");
    }
  };

  if (document.readyState === "complete") {
    await register();
  } else {
    window.addEventListener("load", () => {
      void register();
    });
  }
}

const WebPlugin: PlatformPlugin<void> = {
  name: "web",
  canBoot() {
    return true;
  },
  async boot() {
    if (typeof window !== "undefined") {
      const platform = new URL(window.location.href).searchParams.get("platform");
      if (platform?.toLowerCase() === "dynamics") {
        return;
      }
    }

    await registerServiceWorker();
  },
};

export default WebPlugin;
